// extracted by mini-css-extract-plugin
export default {"tag":"_3aaoY__MhP"};
    if(module.hot) {
      // 1633091695405
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  